//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import thumbnail from '@/assets/imgs/mindshare.png';
import abstract from '@/assets/imgs/post-abstract.svg';
import { post } from '@/mixins/wp-post';

export default {
  name: 'KnockPost',

  mixins: [post(({ route }) => route.params.slug)],

  async asyncData({ params, payload, $wpJson }) {
    if (payload) {
      return payload;
    }

    const { slug } = params;
    const catNames = [];
    let post;
    let categories = [];
    let posts = [];

    try {
      post = await $wpJson.posts.getBySlug(slug);
      post.categories = post.categories.filter((cat) => cat !== 1);
    }
    catch (err) {
      console.error(err);
    }

    try {
      (categories = await $wpJson.posts.getCats());
    }
    catch (err) {
      console.error(err);
    }

    try {
      ({ posts } = await $wpJson.posts.getPreviews({
        perPage: 2
      }));
    }
    catch (err) {
      console.error(err);
    }

    categories = categories.filter((cat) => cat.count !== 0);

    categories.some((cat, id) => cat.id === 1 && categories.unshift(
      categories.splice(id, 1)[0]
    ));

    categories.forEach((category) => {
      catNames[category.id] = category.name;
    });

    return { post, catNames, posts };
  },

  data() {
    return {
      thumbnail,
      shareOffset: 0,
      showPopup: false,
      dragStartY: null,
      dragOffset: 0,
      isDragging: false,
      dragOpenThreshold: 25
    };
  },

  computed: {
    bannerBg() {
      return `background:  url("${abstract}") no-repeat right top/auto calc(100% - 24px) #131212`;
    }
  },

  mounted() {
    this.computeShareOffset();
    window.addEventListener('resize', this.computeShareOffset);

    if (
      !this.isMobileViewport()
      && !window.sessionStorage.getItem('popupDismissed')
      && (this.post.acf.title || this.post.acf.logo)
    ) {
      this.showPopup = true;
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.computeShareOffset);
  },

  updated() {
    this.$nextTick(() => {
      this.$refs.article.querySelectorAll('script').forEach((script) => {
        const newScript = document.createElement('script');
        newScript.text = script.innerHTML;

        Array.from(script.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });

        script.parentNode.replaceChild(newScript, script);
      });
    });
  },

  methods: {
    closePopup() {
      this.showPopup = false;
      window.sessionStorage.setItem('popupDismissed', 'true');
    },

    openPopup() {
      if (this.post.acf.title || this.post.acf.logo) {
        this.showPopup = true;
      }
    },

    handleFloatTouchStart(event) {
      if (!this.isMobileViewport()) {
        return;
      }

      this.dragStartY = event.touches[0].clientY;
    },

    handleFloatTouchMove(event) {
      if (this.dragStartY === null) {
        return;
      }

      const deltaY = this.dragStartY - event.touches[0].clientY;

      // Ignore small jitter so a plain tap doesn't get treated as a drag,
      // and only track upward movement (dragging the sheet down does nothing).
      if (!this.isDragging && deltaY > 8) {
        this.isDragging = true;
      }

      if (this.isDragging) {
        this.dragOffset = Math.max(0, Math.min(deltaY, this.dragOpenThreshold * 2));
        // Stop the page from scrolling underneath the sheet while it's being dragged.
        event.preventDefault();
      }
    },

    handleFloatTouchEnd() {
      if (this.isDragging && this.dragOffset > this.dragOpenThreshold) {
        this.openPopup();
      }

      this.dragStartY = null;
      this.dragOffset = 0;
      this.isDragging = false;
    },

    isMobileViewport() {
      // Keep in sync with $breakpoint-sm in assets/css/variables.scss,
      // which is also where .contact-float switches to its mobile layout.
      return window.matchMedia('(max-width: 768px)').matches;
    },

    toDate(string) {
      const today = new Date(string);
      return today.toDateString();
    },

    getLogo(post) {
      if (post?.thumbnail?.source_url) {
        return post.thumbnail.source_url;
      }
      return this.thumbnail;
    },

    computeShareOffset() {
      this.shareOffset = this.$refs.article.firstElementChild.offsetHeight + 60;
    }
  }
};
